import { render, staticRenderFns } from "./TransactionString.vue?vue&type=template&id=06acedfa&functional=true&"
import script from "./TransactionString.vue?vue&type=script&lang=ts&"
export * from "./TransactionString.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports